import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=7b470aae&scoped=true&"
import script from "./EditDialog.vue?vue&type=script&lang=ts&"
export * from "./EditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditDialog.vue?vue&type=style&index=0&id=7b470aae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b470aae",
  null
  
)

export default component.exports